import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export default {
  header: () => i18n.t(i18nKeys.privacy_manageAccount_header),
  deleteAccountHeader: () =>
    i18n.t(i18nKeys.privacy_manageAccount_deleteAccount_header_new),
  deleteAccountBody: () =>
    i18n.t(i18nKeys.privacy_manageAccount_deleteAccount_body_new),
  deleteAccountButton: () =>
    i18n.t(i18nKeys.privacy_manageAccount_deleteAccount_button),
  exitDeletion: {
    gotItButton: () => i18n.t(i18nKeys.privacy_exitDeletion_gotItButton),
    pageTitle: () => i18n.t(i18nKeys.privacy_exitDeletion_pageTitle_new),
    body1: () => i18n.t(i18nKeys.privacy_exitDeletion_body1_new),
    body2: () => i18n.t(i18nKeys.privacy_exitDeletion_body2_new),
  },
  confirmDeletion: {
    deleteAccountButton: () =>
      i18n.t(i18nKeys.privacy_confirmDeletion_deleteAccountButton_new),
    cancelButton: () => i18n.t(i18nKeys.privacy_confirmDeletion_cancelButton),
    pageTitle: () => i18n.t(i18nKeys.privacy_confirmDeletion_pageTitle_new),
    body1: () => i18n.t(i18nKeys.privacy_confirmDeletion_body1_new),
  },
  requestDeletion: {
    continueButton: () =>
      i18n.t(i18nKeys.privacy_requestDeletion_continueButton),
    cancelButton: () => i18n.t(i18nKeys.privacy_requestDeletion_cancelButton),
    pageTitle: () => i18n.t(i18nKeys.privacy_requestDeletion_pageTitle),
    body1: () => i18n.t(i18nKeys.privacy_requestDeletion_body1_new),
    body2: () => i18n.t(i18nKeys.privacy_requestDeletion_body2_new),
    body3: () => i18n.t(i18nKeys.privacy_requestDeletion_body3_new),
    body4: () => i18n.t(i18nKeys.privacy_requestDeletion_body4_new),
  },
  blockDeletion: {
    payoutButton: () =>
      i18n.t(i18nKeys.privacy_blockDeletion_payoutButton),
    cancelButton: () => i18n.t(i18nKeys.privacy_blockDeletion_cancelButton_new),
    pageTitle: (balance) => i18n.t(i18nKeys.privacy_blockDeletion_pageTitle_new, { balance }),
    body1: () => i18n.t(i18nKeys.privacy_blockDeletion_body1),
    body2: () => i18n.t(i18nKeys.privacy_blockDeletion_body2),
  },
}
